// extracted by mini-css-extract-plugin
export default {"btn":"GetStartedButton_btn__yASak","btnAnim":"GetStartedButton_btnAnim__4zZI7"};